
import React from 'react';
import { Badge } from "@/components/ui/badge";

interface DiscountRibbonProps {
  discountType: 'fixed' | 'percentage';
  discountValue: number;
}

export const DiscountRibbon: React.FC<DiscountRibbonProps> = ({ discountType, discountValue }) => {
  const discountText = discountType === 'percentage' 
    ? `-${discountValue}%` 
    : `-Rp${discountValue.toLocaleString('id-ID')}`;

  return (
    <Badge 
      className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 font-semibold text-white px-3 py-1.5 rounded-md text-sm"
      variant="destructive"
    >
      {discountText}
    </Badge>
  );
};
